import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../_metronic/_partials/controls";

export function PaypalRequestsLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.paypalRequests.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
